import { render, staticRenderFns } from "./report-product-transaction-summary.vue?vue&type=template&id=6f6fb55a&scoped=true&"
import script from "./report-product-transaction-summary.vue?vue&type=script&lang=js&"
export * from "./report-product-transaction-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6fb55a",
  null
  
)

export default component.exports